// import React, { useState } from "react";

// import { connect } from "react-redux";
// import { Link } from "react-router-dom";


// import NotificationDropdown from "../../components/Common/TopbarDropdown/NotificationDropdown";

// //i18n
// import { withTranslation } from "react-i18next";

// //import images
// import logoSm from "../../assets/images/logo.png"
// import logoDark from "../../assets/images/logo.png";
// import logoLight from "../../assets/images/logo.png";

// // Redux Store
// import {
//   showRightSidebarAction,
//   toggleLeftmenu,
//   changeSidebarType,
// } from "../../store/actions";
// import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";


// const Header = (props) => {
//   const [search, setsearch] = useState(false);

//   function toggleFullscreen() {
//     if (
//       !document.fullscreenElement &&
//       /* alternative standard method */ !document.mozFullScreenElement &&
//       !document.webkitFullscreenElement
//     ) {
//       // current working methods
//       if (document.documentElement.requestFullscreen) {
//         document.documentElement.requestFullscreen();
//       } else if (document.documentElement.mozRequestFullScreen) {
//         document.documentElement.mozRequestFullScreen();
//       } else if (document.documentElement.webkitRequestFullscreen) {
//         document.documentElement.webkitRequestFullscreen(
//           Element.ALLOW_KEYBOARD_INPUT
//         );
//       }
//     } else {
//       if (document.cancelFullScreen) {
//         document.cancelFullScreen();
//       } else if (document.mozCancelFullScreen) {
//         document.mozCancelFullScreen();
//       } else if (document.webkitCancelFullScreen) {
//         document.webkitCancelFullScreen();
//       }
//     }
//   }

//   function tToggle() {
//     var body = document.body;
//     if (window.screen.width <= 998) {
//        body.classList.toggle("sidebar-enable");
//     } else {
//       body.classList.toggle("vertical-collpsed");
//       body.classList.toggle("sidebar-enable");
//     }
//   }

//   return (
//     <React.Fragment>
//       <header id="page-topbar">
//         <div className="navbar-header ">
// <div className="d-flex">
//   <div className="navbar-brand-box text-center">
//     <Link to="/" className="logo logo-dark">
//       <span className="logo-sm">
//         <img src={logoSm} alt="logo-sm-dark" style={{width:'70px'}}/>
//       </span>
//       <span className="logo-lg">
//         <img src={logoDark} alt="logo-dark" style={{width:'70px'}}/>
//       </span>
//     </Link>

//     <Link to="/" className="logo logo-light">
//       <span className="logo-sm">
//         <img src={logoSm} alt="logo-sm-light"  style={{width:'70px'}}/>
//       </span>
//       <span className="logo-lg">
//         <img src={logoLight} alt="logo-light"  style={{width:'120px'}}/>
//       </span>
//     </Link>
//   </div>


// </div>

//           <div className="d-flex">
//             <form className="app-search d-none d-lg-block">
//               {/* <div className="position-relative">
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Search..."
//                 />
//                 <span className="ri-search-line"></span>
//               </div> */}
//             </form>
//           </div>
//           <div className="d-flex">
//             <div className="dropdown d-inline-block d-lg-none  ms-2">
//               {/* <button
//                 onClick={() => {
//                   setsearch(!search);
//                 }}
//                 type="button"
//                 className="btn header-item noti-icon "
//                 id="page-header-search-dropdown"
//               >
//                 <i className="ri-search-line" />
//               </button> */}
//               <div
//                 className={
//                   search
//                     ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show res-search-bar"
//                     : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
//                 }
//                 aria-labelledby="page-header-search-dropdown"
//               >
//                  <form className="p-3">
//                   <div className="form-group m-0">
//                     <div className="input-group align-items-center">
//                       <input
//                         type="text"
//                         className="form-control me-1"
//                         placeholder="Search ..."
//                         aria-label="Recipient's username"
//                         style={{borderRadius:'6px'}}
//                       />
//                       <div className="input-group-append">
//                         <button className="btn btn-primary" type="submit">
//                           <i className="ri-search-line f-16" />
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </form>
//               </div>
//             </div>

//             {/* <div className="dropdown d-none d-lg-inline-block ms-1">
//               <button
//                 type="button"
//                 onClick={() => {
//                   toggleFullscreen();
//                 }}
//                 className="btn header-item noti-icon"
//                 data-toggle="fullscreen"
//               >
//                 <i className="ri-fullscreen-line" />
//               </button>
//             </div> */}

//             <NotificationDropdown />

//             <ProfileMenu />
//           </div>
//         </div>
//       </header>
//     </React.Fragment>
//   );
// };

// const mapStatetoProps = (state) => {
//   const { layoutType, showRightSidebar, leftMenu, leftSideBarType } =
//     state.Layout;
//   return { layoutType, showRightSidebar, leftMenu, leftSideBarType };
// };

// export default connect(mapStatetoProps, {
//   showRightSidebarAction,
//   toggleLeftmenu,
//   changeSidebarType,
// })(withTranslation()(Header));



import React, { useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import NotificationDropdown from "../../components/Common/TopbarDropdown/NotificationDropdown";
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";

// Import images
import logoSm from "../../assets/images/custom/logo1.png";
import logoDark from "../../assets/images/custom/logo1.png";
import logoLight from "../../assets/images/custom/logo1.png";
import { setSearchTerm } from "../../store/actions"

import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";

const Header = (props) => {
  const { searchTerm, setSearchTerm } = props;
  const [filteredResults, setFilteredResults] = useState([]);

  const data = ["Dashboard", "Reports", "Users", "Settings", "Notifications"];

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);  // Dispatch the action to update searchTerm in Redux store
  };

  return (
    <>
      <header className="header">
        {/* Logo Section */}
        <div className="logo-container">
            <img src={logoSm} alt="logo" className="logo-img" />
        </div>
        
        <div className="right-section">
          {/* Search Bar */}
          <div className="right-section">
            <div className="search-container">
              <input
                type="text"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearch}
                className="search-input"
              />
            </div>
          </div>

          {/* Notifications */}
          {/* <div className="notification-icon">
            <i className="ri-notification-3-line" />
            <span className="notification-badge">6</span>
          </div> */}

          {/* Profile Menu */}
          <ProfileMenu />
        </div>
      </header>

      {/* Styled JSX */}
      <style jsx>{`
        .header {
          background-color: rgb(34, 106, 184);
          padding: 5px 20px;
          height: 50px; /* Compact header */
          border-bottom: 1px solid #ddd;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        /* Logo */
        .logo-container {
          display: flex;
          align-items: center;
        }

        .logo-img {
          width: 120px; /* Increased size */
        }

        /* Right Section: Search, Notifications, Profile */
        .right-section {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        /* Search Bar */
        .search-container {
          position: relative;
          width: 200px;
        }

        .search-input {
          width: 100%;
          padding: 6px 10px;
          font-size: 14px;
          border-radius: 4px;
          border: 1px solid #ccc;
          outline: none;
        }

        /* Search Results Dropdown */
        .search-results {
          position: absolute;
          top: 100%;
          left: 0;
          width: 100%;
          background-color: #fff;
          border: 1px solid #ccc;
          border-radius: 4px;
          box-shadow: 0px 4px 6px hsla(0, 0.00%, 0.00%, 0.10);
          margin-top: 4px;
          z-index: 10;
        }

        .search-item {
          padding: 6px;
          cursor: pointer;
          border-bottom: 1px solid #eee;
          font-size: 14px;
        }

        .search-item:hover {
          background-color: #f5f5f5;
        }

        .no-results {
          color: #999;
          font-size: 14px;
        }

        /* Notification Icon */
        .notification-icon {
          position: relative;
          cursor: pointer;
          font-size: 20px;
          color:rgb(238, 228, 228);
        }

        .notification-badge {
          position: absolute;
          top: -5px;
          right: -5px;
          background-color: #e30613;
          color: #fff;
          font-size: 10px;
          border-radius: 50%;
          padding: 2px 5px;
        }
      `}</style>
    </>
  );
};

const mapStateToProps = (state) => ({
  searchTerm: state.searchTerm.searchTerm,  // Access searchTerm from the Redux store
});

const mapDispatchToProps = {
  setSearchTerm,  // Action creator to dispatch search term
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);



